import { useUserProgramContext } from 'Contexts/UserProgramContext'
import { useUserInfoContext } from 'Contexts/UserInfoContext'
import { useOngoingPurchaseInfo } from 'Hooks/useOngoingPurchaseInfo'

export const useProgramOngoingPurchaseInfo = (programId?: string, amount?: number) => {
  const {
    state: { programs }
  } = useUserProgramContext()

  const {
    state: { userId }
  } = useUserInfoContext()

  const selectedProgram = programs.find((program) => program.id.toString() === programId)

  return useOngoingPurchaseInfo(
    userId,
    selectedProgram && {
      name: selectedProgram.name,
      ongoingPurchases: selectedProgram.membership.ongoingPurchases ?? false,
      allowance: selectedProgram.currentPeriodAllowance,
      threshold: selectedProgram.membership.ongoingPurchaseThreshold ?? 0
    },
    amount
  )
}
